function ShopAll() {
  return (
    <div className="p-8 text-center">
      <h1 className="text-4xl font-bold mb-4">Shop All Courses</h1>
      <p className="text-lg text-gray-700">Explore all available learning products here.</p>
    </div>
  );
}
export default ShopAll;